import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getResults } from '../services/api';
import { Results, TabType } from '../types/results';

export const useResults = (attemptId: string | undefined, language: 'en' | 'fr' | 'ar' = 'fr') => {
  const [results, setResults] = useState<Results | null>(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState<TabType>('summary');
  const navigate = useNavigate();

  // Map UI language codes to result display language names
  const languageMap = {
    'en': 'english',
    'fr': 'french',
    'ar': 'arabic'
  } as const;

  const displayLanguage = languageMap[language];

  const loadResults = useCallback(async () => {
    if (!attemptId) {
      navigate('/dashboard');
      return;
    }

    setLoading(true);
    try {
      console.log(`[useResults] Fetching results for attempt ${attemptId} with language: ${displayLanguage}`);
      const response = await getResults(Number(attemptId), displayLanguage);
      console.log(`[useResults] Received results:`, response.data);
      setResults(response.data);
    } catch (err) {
      console.error('[useResults] Error:', err);
      alert('Error loading results');
      navigate('/dashboard');
    } finally {
      setLoading(false);
    }
  }, [attemptId, navigate, displayLanguage]);

  useEffect(() => {
    loadResults();
  }, [loadResults]);

  return {
    results,
    loading,
    activeTab,
    setActiveTab,
  };
};
